import { Component } from '@angular/core';

@Component({
    selector: 'ngx-footer',
    styleUrls: ['./footer.component.scss'],
    template: `
    <span class="created-by">Created with ♥ by <b><a href="https://www.framewerx.ca" target="_blank">Framewerx</a></b> © 2019 - {{currentYear}}</span>
  `,
    standalone: false
})
/**
 * Handles footercomponent for this module.
 */
export class FooterComponent {
  currentYear = new Date().getFullYear();
}


